module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-446.77bffea.woff2";